import getCmp from "./helpers/cmpHelpers";

let umeGlobalTabIndex = {};
const consentmanagerHandleBackground = () => {
    const cmp = getCmp();
    if (cmp !== null) {
        cmp('addEventListener', ['consentscreen', handleConsentScreen, false], null)
        cmp('addEventListener', ['consentscreenoff', handleConsentScreen, false], null)
    }
}
export default consentmanagerHandleBackground;

const handleConsentScreen = (e, o) => {
    if (e === 'consentscreen') {
        document.body.classList.add('modal-open');
        umeGlobalTabIndex = lockTabIndex();
    }
    if (e === 'consentscreenoff') {
        document.body.classList.remove('modal-open');
        if (umeGlobalTabIndex && Object.keys(umeGlobalTabIndex).length > 0) {
            unlockTabIndex(umeGlobalTabIndex);
        }

    }
}
const lockTabIndex = () => {
    const selector =
        'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    const tabElements = document.querySelectorAll(selector);
    let tabArray = Array.from(tabElements)
        .map((elem) => {

            const tabIndex = elem.hasAttribute("tabindex")
                ? elem.getAttribute("tabindex")
                : null;

            elem.setAttribute("tabindex", -1);
            return {elem, tabIndex};
        })
    return tabArray;
}
const unlockTabIndex = (oldState) => {
    oldState.forEach(({elem, tabIndex}) => {
        if (tabIndex === null) {
            elem.removeAttribute("tabindex");
        } else {
            elem.setAttribute("tabindex", tabIndex);
        }
    });
}